import './autocompleteChips.scss'
import templateUrl from './autocompleteChips.html'

/**
 * Autocomplete-Chips form field component.
 *
 * @example
 * <tmr-autocomplete-chips
 *   resource-service="Zone"
 *   selected-items=""
 *   filter="{ 'place.id' = '' }"
 *   min-search-length=""
 *   label-select=""
 *   label-help=""
 *   no-cache=""
 *   is-disabled=""
 *   is-required=""
 *   on-change=""
 * ></tmr-autocomplete-chips>
 *
 * @type {ngComponent}
 * @prop {string} resource-service TmrResource type for query
 * @prop {array} selected-items Array of selected items
 * @prop {object} filter default filter for resource query
 * @prop {number=} [min-search-length=3] minimum text length for the query to run. Used only if filter is empty
 * @prop {string} label-select label for md-autocomplete
 * @prop {string=} label-help label for help text below the field
 * @prop {boolean=} [no-cache=false] Disable query caching on md-autocomplete
 * @prop {boolean=} [is-disabled=false]
 * @prop {required=} [is-required=false]
 * @prop {function} on-change callback function
 */
export const tmrAutocompleteChips = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAutocompleteChipsController',
  bindings: {
    resourceService: '@',
    selectedItems: '<',
    filter: '<',
    minSearchLength: '<?',
    labelSelect: '@',
    labelHelp: '@?',
    noCache: '<?',
    isDisabled: '<?',
    isRequired: '<?',
    onChange: '&',
  },
}

/**
 * Controller of component {@link tmrAutocompleteChips}.
 *
 * @type {ngController}
 */
export class tmrAutocompleteChipsController {
  static ngType = 'controller'

  constructor($injector) {
    'ngInject'
    Object.assign(this, { $injector })
  }

  $onInit() {
    this.resourceServiceObj = this.$injector.get(this.resourceService)
    this.minSearchLength = this.minSearchLength ?? 3
  }

  /** Execute a filtered query on resource */
  querySearch(value) {
    if (this.hasFilters()) {
      return this.resourceServiceObj.query(
        Object.assign(this.filter, { description: value })
      ).$promise
    }
    return this.resourceServiceObj.search({ value }).$promise
  }

  hasFilters() {
    return this.filter && Object.values(this.filter).length > 0
  }

  /** Add item to selectedItems and callback onChange */
  onChangeSelect() {
    // Check if selected item is already in selectedItems
    if (
      this.selectedItem &&
      (!this.selectedItems ||
        !this.selectedItems.filter(item => item.id == this.selectedItem.id)
          .length)
    ) {
      this.selectedItems.push(this.selectedItem)
      this.onChange({ selectedItems: this.selectedItems })
    }
    this.selectedItem = null
  }

  /** Remove item from selectedItems and callback onChange */
  onRemoveChips() {
    this.onChange({ selectedItems: this.selectedItems })
  }
}
